import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { RobotThinkingFaceComponent } from './robot-thinking-face/robot-thinking-face.component';

@Component({
  selector: 'app-ai-drafting-progress',
  templateUrl: './ai-drafting-progress.component.html',
  styleUrls: ['./ai-drafting-progress.component.scss', '../../global-workspace-styles.scss'],
  standalone: true,
  imports: [MatProgressBarModule, MatIconModule, MatCard, RobotThinkingFaceComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiDraftingProgressComponent {}
